import { createApi } from '@reduxjs/toolkit/query/react';
import { CreateAiTaskRequestIF, AiTaskModelIF } from '@/api/aiApi/types';
import { fetchRestApiQuery } from '@/helpers/api';

export const aiApi = createApi({
    reducerPath: 'aiApi',
    baseQuery: fetchRestApiQuery('/Ai'),
    endpoints: (builder) => ({
        createAiTask: builder.mutation<AiTaskModelIF, CreateAiTaskRequestIF>({
            query: (body) => ({
                url: '',
                method: 'POST',
                body,
            }),
        }),
        getAiTask: builder.mutation<AiTaskModelIF, string>({
            query: (guid) => `/${guid}`,
        }),
    }),
});
